import { render, staticRenderFns } from "./income_detail.vue?vue&type=template&id=18e2b8af&scoped=true"
import script from "./income_detail.vue?vue&type=script&lang=js"
export * from "./income_detail.vue?vue&type=script&lang=js"
import style0 from "./income_detail.vue?vue&type=style&index=0&id=18e2b8af&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e2b8af",
  null
  
)

export default component.exports